import { BOverlay } from './overlay';
import { pluginFactory } from '../../utils/plugins';
var OverlayPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BOverlay: BOverlay
  }
});
export { OverlayPlugin, BOverlay };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/overlay/index.js
// module id = 279
// module chunks = 0